import { leadInstance } from '@/libs/leadInstances';

export async function getRegions() {
  return leadInstance.get('/leads/regions');
}

export async function getCitiesByRegion(idRegion) {
  return leadInstance.get(`/leads/regions/${idRegion}/cities`);
}
